import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { captchaConfig, isCaptchaEnabled } from '../../lib/captchaConfig';


interface ReCaptchaProps {
    onChange?: (token: string | null) => void;
    onExpired?: () => void;
    onError?: () => void;
    theme?: 'light' | 'dark';
    size?: 'compact' | 'normal' | 'invisible';
    className?: string;
}

export interface ReCaptchaRef {
    reset: () => void;
    execute: () => void;
    getValue: () => string | null;
}

const ReCaptcha = forwardRef<ReCaptchaRef, ReCaptchaProps>(
    ({ onChange, onExpired, onError, theme = captchaConfig.theme, size = captchaConfig.size, className }, ref) => {
        const recaptchaRef = useRef<ReCAPTCHA>(null);

        useImperativeHandle(ref, () => ({
            reset: () => {
                recaptchaRef.current?.reset();
            },
            execute: () => {
                recaptchaRef.current?.execute();
            },
            getValue: () => {
                return recaptchaRef.current?.getValue() || null;
            },
        }));

        // Don't render if captcha is disabled or no site key
        if (!isCaptchaEnabled()) {
            return null;
        }

        return (
            <div className={className}>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={captchaConfig.siteKey}
                    onChange={onChange}
                    onExpired={onExpired}
                    onError={onError}
                    theme={theme}
                    size={size}
                />
            </div>
        );
    }
);

ReCaptcha.displayName = 'ReCaptcha';

export default ReCaptcha;
